/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update the appointment general message
 * @export
 * @interface AppointmentGeneralMessageRequest
 */
export interface AppointmentGeneralMessageRequest {
    /**
     * the general message displayed to the patient when they want to book an appointment
     * @type {string}
     * @memberof AppointmentGeneralMessageRequest
     */
    generalMessage?: string;
}

/**
 * Check if a given object implements the AppointmentGeneralMessageRequest interface.
 */
export function instanceOfAppointmentGeneralMessageRequest(value: object): value is AppointmentGeneralMessageRequest {
    return true;
}

export function AppointmentGeneralMessageRequestFromJSON(json: any): AppointmentGeneralMessageRequest {
    return AppointmentGeneralMessageRequestFromJSONTyped(json, false);
}

export function AppointmentGeneralMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentGeneralMessageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'generalMessage': json['generalMessage'] == null ? undefined : json['generalMessage'],
    };
}

export function AppointmentGeneralMessageRequestToJSON(json: any): AppointmentGeneralMessageRequest {
    return AppointmentGeneralMessageRequestToJSONTyped(json, false);
}

export function AppointmentGeneralMessageRequestToJSONTyped(value?: AppointmentGeneralMessageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'generalMessage': value['generalMessage'],
    };
}

